module.exports = __webpack_public_path__ + "static/Civil Adjudication-3573883e2066b2b15318a3f7a42cc800.jpg";